import { Promotion, PromotionDisplayType } from "src/types/graphql.d";
import { PromotionalRibbonWrapper } from "./PromotionalRibbon.styled";
import { Timer } from "src/atoms/Timer";
import { CloseButton } from "src/atoms/CloseButton";
import { theme } from "src/theme";
import { ReactNode, useCallback, useState } from "react";
import { usePromotionContext } from "src/hooks/usePromotionContext";
import { createPortal } from "react-dom";

type PromotionalRibbonProps = {
  icon: ReactNode;
  promotion: Promotion;
  message: string;
};

function PromotionalRibbon({
  icon,
  promotion,
  message,
}: PromotionalRibbonProps): JSX.Element | null {
  const [showPromotionalRibbon, setShowPromotionalRibbon] = useState(true);
  const { promotionContextDispatch, promotionContextState } =
    usePromotionContext();

  const onClose = () => setShowPromotionalRibbon(!showPromotionalRibbon);

  const handleTimerEnd = useCallback(
    () =>
      promotionContextDispatch({ type: "SET_PROMO_STATUS", payload: false }),
    [promotionContextDispatch]
  );

  return showPromotionalRibbon &&
    promotion.promo_display_type === PromotionDisplayType.LightningDeal &&
    !promotionContextState.hasPromotionEnded
    ? createPortal(
        <PromotionalRibbonWrapper
          backgroundColor={promotion.promo_highlight_color as string}
          textColor={theme.colors.tone.white}
          highlightColor={theme.colors.tone.white}
        >
          <div className="message">
            {icon ? icon : null}
            {message}
            <Timer
              onTimerEnd={handleTimerEnd}
              endDate={promotion.promo_end_date || ""}
              showLabels={false}
              theme="bannertimer"
              hideTimerBlocks={{ days: true }}
              timerColor={theme.colors.tone.white}
            />
          </div>
          <div className="actions">
            <CloseButton fill={theme.colors.tone.white} onClick={onClose} />
          </div>
        </PromotionalRibbonWrapper>,
        document.body
      )
    : null;
}

export { PromotionalRibbon };
